import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	advanced: {
		id: 'spa-apps-sidebar-global-settings-system.menu.advanced.advanced',
		defaultMessage: 'Advanced',
		description: 'Navigation group heading for advanced settings items',
	},
	attachments: {
		id: 'spa-apps-sidebar-global-settings-system.menu.advanced.attachments',
		defaultMessage: 'Attachments',
		description: 'Navigation item which links to a attachments settings page',
	},
	events: {
		id: 'spa-apps-sidebar-global-settings-system.menu.advanced.events',
		defaultMessage: 'Events',
		description: 'Navigation item which links to a events settings page',
	},
	webhooks: {
		id: 'spa-apps-sidebar-global-settings-system.menu.advanced.webhooks',
		defaultMessage: 'WebHooks',
		description: 'Navigation item which links to a webhooks settings page',
	},
	lexorankManagement: {
		id: 'spa-apps-sidebar-global-settings-system.menu.advanced.lexorank-management',
		defaultMessage: 'LexoRank management',
		description: 'Navigation item which links to a lexorank management settings page',
	},
});
